<p-confirmDialog #cd>
  <p-footer>
    <div class="flex justify-content-end gap-2">
      <button
        pButton
        type="button"
        label="No"
        class="p-button-text"
        (click)="cd.reject()"
      ></button>
      <button
        pButton
        type="button"
        label="Yes"
        (click)="cd.accept()"
      ></button>
    </div>
  </p-footer>
</p-confirmDialog>

<p-toast key="vehicles"></p-toast>

<div class="vehicle-page">
  <header class="vehicle-header">
    <div class="vehicle-header__identity">
      <div class="vehicle-header__icon" aria-hidden="true">
        <i class="pi pi-truck"></i>
      </div>

      <div class="vehicle-header__copy">
        <h1>Vehicles</h1>
        <p>Fleet registry <span>&middot;</span> Updated just now</p>
      </div>
    </div>

    <div class="vehicle-header__status" aria-label="Fleet records available">
      <span class="vehicle-header__status-dot"></span>
      <span>Fleet records</span>
    </div>
  </header>

  <div class="vehicle-content">
  <div *ngIf="Vehicles$ | async; else loadedContent">
    <div class="vehicle-loading">
      <p-progressSpinner></p-progressSpinner>
    </div>
  </div>

  <ng-template #loadedContent>
    <div class="block surface-panel w-full" style="max-width: 100vw">
      <p-tabView>
        <p-tabPanel header="Vehicles">
          <p-table
            #dt
            [value]="(vehicles$ | async) || []"
            [tableStyle]="{ 'min-width': '70rem' }"
            [rowHover]="true"
            responsiveLayout="scroll"
            [scrollable]="true"
            scrollHeight="75vh"
            styleClass="app-table p-datatable-sm lg:p-datatable-md"
            [globalFilterFields]="[
              'vehicle_reference',
              'vehicle_make',
              'vehicle_model',
              'vehicle_year',
              'chassis_no',
              'model',
              'engine_no'
            ]"
          >
            <ng-template pTemplate="caption">
              <div
                class="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-3 py-2"
              >
                <div class="flex flex-wrap gap-2">
                  <button
                    pButton
                    type="button"
                    icon="pi pi-plus"
                    label="Add Vehicle"
                    class="p-button-sm p-button-outlined"
                    (click)="showAdd($event)"
                  ></button>
                </div>

                <div class="w-full md:w-auto">
                  <span class="p-input-icon-left p-input-icon-right w-full">
                    <i class="pi pi-search"></i>
                    <input
                      pInputText
                      type="text"
                      class="w-full md:w-20rem"
                      [value]="vehicleSearch"
                      (input)="filterGlobal($event)"
                      placeholder="Search keyword"
                    />
                    <i
                      *ngIf="vehicleSearch"
                      class="pi pi-times"
                      style="cursor:pointer"
                      (click)="clearVehicleSearch()"
                    ></i>
                  </span>
                </div>
              </div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                  <div class="flex align-items-center">
                    <span>{{ col.header }}</span>
                    <p-columnFilter
                      type="text"
                      [field]="col.field"
                      display="menu"
                    ></p-columnFilter>
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                  </div>
                </th>
                <th></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-vehicle>
              <tr style="cursor: pointer">
                <td
                  *ngFor="let col of columns"
                  (click)="selectVehicle(vehicle)"
                  [class.mono-cell]="
                    col.field === 'engine_no' ||
                    col.field === 'chassis_no' ||
                    col.field === 'year_model' ||
                    col.field === 'date_inservice' ||
                    col.field === 'service_interval'
                  "
                >
                  <div class="flex align-items-center">
                    <span class="font-medium text-sm md:text-base text-color-primary">
                      {{ vehicle[col.field] }}
                    </span>
                  </div>
                </td>

                <td class="text-right">
                  <button
                    type="button"
                    pButton
                    icon="pi pi-ellipsis-v"
                    class="p-button-sm p-button-text p-button-secondary"
                    (click)="menu.toggle($event); storeRowDetail(vehicle); $event.stopPropagation()"
                  ></button>

                  <p-menu
                    #menu
                    [model]="items"
                    [popup]="true"
                    appendTo="body"
                  ></p-menu>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="100%">
                  <div class="flex align-items-center justify-content-center py-4">
                    <span class="text-800 font-medium text-xl">
                      No vehicles found
                    </span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-tabPanel>

        <p-tabPanel header="Archived Vehicles">
          <p-table
            #archivedDt
            [value]="(archivedVehicles$ | async) || []"
            [tableStyle]="{ 'min-width': '70rem' }"
            [rowHover]="true"
            responsiveLayout="scroll"
            [scrollable]="true"
            scrollHeight="75vh"
            styleClass="app-table p-datatable-sm lg:p-datatable-md"
            [globalFilterFields]="[
              'vehicle_reference',
              'vehicle_make',
              'vehicle_model',
              'vehicle_year',
              'chassis_no',
              'model',
              'engine_no'
            ]"
          >
            <ng-template pTemplate="caption">
              <div
                class="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-3 py-2"
              >
                <div class="flex align-items-center gap-2">
                  <span class="text-800 font-medium">Archived vehicles</span>
                </div>

                <div class="w-full md:w-auto">
                  <span class="p-input-icon-left p-input-icon-right w-full">
                    <i class="pi pi-search"></i>
                    <input
                      pInputText
                      type="text"
                      class="w-full md:w-20rem"
                      [value]="archivedSearch"
                      (input)="filterArchivedGlobal($event)"
                      placeholder="Search keyword"
                    />
                    <i
                      *ngIf="archivedSearch"
                      class="pi pi-times"
                      style="cursor:pointer"
                      (click)="clearArchivedSearch()"
                    ></i>
                  </span>
                </div>
              </div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                  <div class="flex align-items-center">
                    <span>{{ col.header }}</span>
                    <p-columnFilter
                      type="text"
                      [field]="col.field"
                      display="menu"
                    ></p-columnFilter>
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                  </div>
                </th>
                <th></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-vehicle>
              <tr style="cursor: pointer">
                <td
                  *ngFor="let col of columns"
                  (click)="selectVehicle(vehicle)"
                  [class.mono-cell]="
                    col.field === 'engine_no' ||
                    col.field === 'chassis_no' ||
                    col.field === 'year_model' ||
                    col.field === 'date_inservice' ||
                    col.field === 'service_interval'
                  "
                >
                  <div class="flex align-items-center">
                    <span class="font-medium text-sm md:text-base text-color-primary">
                      {{ vehicle[col.field] }}
                    </span>
                  </div>
                </td>

                <td class="text-right">
                  <button
                    type="button"
                    pButton
                    icon="pi pi-ellipsis-v"
                    class="p-button-sm p-button-text p-button-secondary"
                    (click)="menu.toggle($event); storeRowDetail(vehicle); $event.stopPropagation()"
                  ></button>

                  <p-menu
                    #menu
                    [model]="archivedOptions"
                    [popup]="true"
                    appendTo="body"
                  ></p-menu>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="100%">
                  <div class="flex align-items-center justify-content-center py-4">
                    <span class="text-800 font-medium text-xl">
                      No archived vehicles found
                    </span>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-tabPanel>
      </p-tabView>
    </div>
  </ng-template>
  </div>
</div>
